//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sameOriginCheck from "../../../global/mixins/sameOriginCheck";

export default {
	name: "AppPopup",
	props: {
		activeResult: Object
	},
	components: {},
	data() {
		return {
			currentUrl: window.location,
			leaveTimer: null,
		};
	},
	computed: {
		isExternalLink() {
			return !sameOriginCheck(this.activeResult.url, this.currentUrl);
		},
		targetBlank() {
			return this.isExternalLink || this.config.openInNewWindow;
		},
		locationMarkup() {
			let location = this.activeResult.meta.location;
			if (!!location && this.activeResult.meta.eventLocation) {
				location += "\r\n" + this.activeResult.meta.eventLocation;
			} else if (this.activeResult.meta.eventLocation) {
				location = this.activeResult.meta.eventLocation;
			}
			return location;
		}
	},
	methods: {
		closePopup() {
			this.$emit('closePopup');
		},
	},
	created() {},
	mounted() {},
};
